import { Tooltip as AntTooltip } from 'antd'
import type { ComponentProps } from 'react'

type AntTooltipProps = ComponentProps<typeof AntTooltip>

export interface AppTooltipProps extends Omit<AntTooltipProps, 'visible'> {
  open?: boolean
}

export const AppTooltip = ({ open, ...rest }: AppTooltipProps) => <AntTooltip open={open} {...rest} />
